// trial-expired-model.js

import { Model } from 'backbone';
import Immutable from 'immutable';

class TrialExpiredModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default TrialExpiredModel;
